import axios from "axios";

export const state = {
    audits: [],
};

export const getters = {
    audits: state => state.audits,
};

export const mutations = {
    setAudits(audits, newValue) { state.audits = newValue},
};

export const actions = {
    fetchAudits({ commit }) {
        axios.get('/audits').then(res => {
            commit('setAudits', res.data.audits)
        })
    },
    filterAudits({commit}, {username,datefrom,dateto}) { 
        let formData = new FormData();
        formData.append("username", username);
        formData.append("datefrom", datefrom);
        formData.append("dateto", dateto);
        let url = "/filteraudits";
        axios.post(url, formData).then((response) => {
            commit('setAudits', response.data.audits)
        })
    },
};
